import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { Link } from "react-router-dom";
import AfterSalesLayout from "../aftersaleslayout/AfterSalesLayout";
import BackBlue from "../../../assets/aftersalesservice_icons/back_blue_icon.svg";
import UserManualIcon from "../../../assets/aftersalesservice_icons/user_manual_icon.svg";
import DownloadWhite from "../../../assets/aftersalesservice_icons/download_white_icon.svg";
import Safety from "../../../assets/aftersalesservice_icons/safety_icon.png";
import QuickAccess from "../../../assets/aftersalesservice_icons/quick_access_icon.svg";
import Installation from "../../../assets/aftersalesservice_icons/installation_icon.png";
import Operating from "../../../assets/aftersalesservice_icons/operating_icon.png";
import Maintenance from "../../../assets/aftersalesservice_icons/maintenance_icon.png";
import FallbackImg from "../../../components/FallbackImg";
import ApiService from "../../../components/Api_services";
import { useLanguage } from "../LanguageContext";
import {
  buildAfterSalesQuery,
  getAfterSalesApiSerial,
  getAfterSalesSerialType,
} from "../serialTypeUtils";

const UserManual = () => {
  const { trans } = useLanguage();
  const [searchParams] = useSearchParams();
  const sn = atob(searchParams.get("sn") || "");
  const getSerialNo = () => sn;
  const serialNoForApi = getAfterSalesApiSerial(searchParams);
  const serialType = getAfterSalesSerialType(searchParams);

  const [warrantyItemList, setWarrantyItemList] = useState([]);
  const [productInfo, setProductInfo] = useState("");

  useEffect(() => {
    const fetchWarrantyInfo = async () => {
      const serialNo = serialNoForApi;

      try {
        const response = await ApiService.getWarrantyInfo(serialNo, serialType);
        // console.log("warranty info:", response);

        if (response && response.status === 200) {
          const items = response.data?.warranty_item_list || [];
          // ensure each item has serial_no
          const normalizedItems = (Array.isArray(items) ? items : []).map(
            (it) => {
              const { item_warranty_period, ...rest } = it || {};
              return {
                ...rest, // rest no longer contains item_warranty_period
                // map item_warranty_period -> warranty_day (ensure numeric)
                warranty_day:
                  rest?.warranty_day ??
                  (item_warranty_period != null
                    ? Number(item_warranty_period)
                    : 0),
              };
            },
          );
          setWarrantyItemList(normalizedItems);
        }
      } catch (error) {
        console.error("Error fetching warranty info:", error);
      }
    };

    fetchWarrantyInfo();
  }, [serialNoForApi, serialType]);

  const firstItemCode =
    warrantyItemList.length > 0
      ? (warrantyItemList[0]?.item_code || "").replace(/\([^)]*\)/g, "").trim()
      : "";

  useEffect(() => {
    const fetchProductInfo = async () => {
      if (!firstItemCode) return;

      try {
        const response = await ApiService.getProductInfo(firstItemCode);

        if (response && response.status === 200) {
          setProductInfo(response.data);
        }
      } catch (error) {
        console.error("Error fetching product info:", error);
      }
    };

    fetchProductInfo();
  }, [firstItemCode]);

  const goBack = (e) => {
    e.preventDefault();
    window.history.back();
  };

  const openPdf = () => {
    window.open(
      "https://file.unity.net.my/document/Philips+Air+Conditioner+-+User+Manual.pdf",
      "_blank",
    );
  };

  return (
    <AfterSalesLayout>
      <div className="as-user-manual-content" id="user_manual_modal">
        <div style={{ padding: "0 31.97px" }}>
          <div className="as-user-manual-container">
            <button
              type="button"
              className="as-back-btn"
              id="user_manual_back"
              onClick={goBack}
            >
              <FallbackImg src={BackBlue} alt="backblue" />
              {trans.back}
            </button>
            <div className="as-user-manual-main">
              <FallbackImg src={UserManualIcon} alt="usermanual" />
              <div>
                <div className="as-user-manual-main-title">
                  {trans.user_manual}
                </div>
                <div className="as-user-manual-main-text">
                  {trans.user_manual_sub}
                </div>
              </div>
            </div>
            <button
              type="button"
              className="as-download-manual-btn"
              onClick={openPdf}
            >
              <FallbackImg src={DownloadWhite} alt="downloadwhite" />
              {trans.download_manual}
            </button>
          </div>

          <div className="as-quick-access-container">
            <div className="as-quick-access-title">{trans.sections}</div>

            <Link
              to={`/aftersalesservice/usermanual/safety${buildAfterSalesQuery(searchParams)}`}
            >
              <div className="as-quick-access-box" id="user_manual_safety_btn">
                <div className="as-quick-access-text">
                  <FallbackImg src={Safety} alt="safety" />
                  <div>
                    <div>{trans.safety_instruct}</div>
                    <div className="as-quick-access-subtext">
                      {trans.safety_instruct_sub}
                    </div>
                  </div>
                </div>
                <div className="as-quick-access-btn">
                  <FallbackImg src={QuickAccess} alt="quickaccess" />
                </div>
              </div>
            </Link>

            <Link
              to={`/aftersalesservice/usermanual/installation${buildAfterSalesQuery(searchParams)}`}
            >
              <div
                className="as-quick-access-box"
                id="user_manual_installation_btn"
              >
                <div className="as-quick-access-text">
                  <FallbackImg src={Installation} alt="installation" />
                  <div>
                    <div>{trans.install_guide}</div>
                    <div className="as-quick-access-subtext">
                      {trans.install_guide_sub}
                    </div>
                  </div>
                </div>
                <div className="as-quick-access-btn">
                  <FallbackImg src={QuickAccess} alt="quickaccess" />
                </div>
              </div>
            </Link>

            <Link
              to={`/aftersalesservice/usermanual/operating${buildAfterSalesQuery(searchParams)}`}
            >
              <div
                className="as-quick-access-box"
                id="user_manual_operating_btn"
              >
                <div className="as-quick-access-text">
                  <FallbackImg src={Operating} alt="operating" />
                  <div>
                    <div>{trans.operate_instruct}</div>
                    <div className="as-quick-access-subtext">
                      {trans.operate_instruct_sub}
                    </div>
                  </div>
                </div>
                <div className="as-quick-access-btn">
                  <FallbackImg src={QuickAccess} alt="quickaccess" />
                </div>
              </div>
            </Link>

            <Link
              to={`/aftersalesservice/usermanual/maintenance${buildAfterSalesQuery(searchParams)}`}
            >
              <div
                className="as-quick-access-box"
                id="user_manual_maintenance_btn"
              >
                <div className="as-quick-access-text">
                  <FallbackImg src={Maintenance} alt="maintenance" />
                  <div>
                    <div>{trans.maint}</div>
                    <div className="as-quick-access-subtext">
                      {trans.maint_sub}
                    </div>
                  </div>
                </div>
                <div className="as-quick-access-btn">
                  <FallbackImg src={QuickAccess} alt="quickaccess" />
                </div>
              </div>
            </Link>
          </div>

          <div className="as-product-info-container">
            <div className="as-product-info-title">{trans.product_info}</div>
            <div className="as-product-info-input">
              <div style={{ color: "#525252" }}>{trans.model_code}</div>
              <div id="model_code">{firstItemCode}</div>
            </div>
            <div className="as-product-info-input">
              <div style={{ color: "#525252" }}>{trans.aircon_type}</div>
              <div id="aircon_type">{productInfo.aircon_type}</div>
            </div>
            <div className="as-product-info-input">
              <div style={{ color: "#525252" }}>{trans.horse_power}</div>
              <div id="horse_power">{productInfo.horse_power}</div>
            </div>
          </div>

          <div className="as-contact-support-container">
            <div className="as-contact-support-text">{trans.need_help}</div>
            <div className="as-contact-support-text">{trans.our_sup_2}</div>
            <Link
              to={`/aftersalesservice/ticketsubmission${buildAfterSalesQuery(
                searchParams,
                {
                  type: "Technical_Consultation_Inquiry",
                },
              )}`}
            >
              <button
                type="button"
                className="as-contact-support-btn"
                id="manual-contact-support-btn"
              >
                {trans.contact_sup}
              </button>
            </Link>
          </div>
        </div>
      </div>
    </AfterSalesLayout>
  );
};

export default UserManual;
